import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useTrackEvent from '../../hooks/useTrackHook';
import { toast } from 'react-toastify';
import { BASE_URL, IMAGE_URL } from '../../Components/client-config';
import mergn from 'mergn-webapp-sdk';
import { useTranslation } from 'react-i18next';

let addBtn, cart: any;
const speed = 500,
  curveDelay = 300,
  position = "fixed";

function init() {
  let addBtn: any = document.querySelectorAll("[data-addToCart]");
  cart = document.querySelector("#cart button");

  for (let btn of addBtn) {

    btn.addEventListener("click", addItem);
  }
}

function addItem(e: any, storeSelected: any) {
  if (storeSelected) {
    let btnY =
      position === "fixed"
        ? e.currentTarget.getBoundingClientRect().top
        : e.currentTarget.offsetTop,
      btnX =
        position === "fixed"
          ? e.currentTarget.getBoundingClientRect().left
          : e.currentTarget.offsetLeft,
      flyingBtn = e.currentTarget.cloneNode();

    cart.classList.remove("addedCount");

    flyingBtn.classList.add("flyingBtn");
    flyingBtn.style.position = position;
    flyingBtn.style.top = `${btnY}px`;
    flyingBtn.style.left = `${btnX}px`;
    flyingBtn.style.opacity = "1";
    flyingBtn.style.transition = `all ${speed / 1000}s ease, top ${(speed +
      curveDelay) /
      1000}s ease, left ${speed / 1000}s ease, transform ${speed /
      1000}s ease ${(speed - 10) / 1000}s`;

    document.body.appendChild(flyingBtn);

    flyingBtn.style.top = `${cart.offsetTop + cart.offsetHeight - 26}px`;
    flyingBtn.style.left = `${cart.offsetLeft + cart.offsetWidth - 26}px`;
    flyingBtn.style.height = "2.5rem";
    flyingBtn.style.width = "2.5rem";
    flyingBtn.style.zIndex = "999";
    flyingBtn.style.fontSize = "25px";
    flyingBtn.style.border = "none";
    flyingBtn.style.transform = "scale(0)";

    setTimeout(() => {
      flyingBtn.remove();
    }, speed * 1.5);
  }
}

const handleAddToCart = (product: any) => {

  const makeItem = {
    name: product.combo_name ? product.combo_name : product.item_name,
    price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
    category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
    url : {
        page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
        product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
    }
  }

  mergn.recordEvent("Add to Bucket", [
    { eventProperty: 'product-name', value: makeItem.name },
    { eventProperty: 'product-price', value: makeItem.price },
    { eventProperty: 'category-name', value: makeItem.category },
    { eventProperty: 'product-page-url', value: makeItem.url.page },
    { eventProperty: 'product-image-url', value: makeItem.url.product }
  ])

}


export default function FlyBtn(props: any) {
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const [addEvent] = useTrackEvent();
  const { t } = useTranslation();

  useEffect(() => {
    init()
  }, [])
  return (
    <div onClick={() => {
      if(props.product.is_active == 0){
        if (storeSelected) {
          toast.error(t("ITEM_NOT_AVAILABLE"), {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
        }
      } else if (props.itemReady(props.product.modifiers)) {
        props.handleAdd(props.product)
        if (props.closeSuggCompoment) {
          props.closeSuggCompoment()
        }
        props.product.combo_name ?
          addEvent({ category: "events", events: `${props?.product?.combo_name} Add to cart` }) :
          addEvent({ category: "events", events: `${props?.product?.item_name} Add to cart` })
        props.handleToogle && props.handleToogle()
      } else {
        toast.error(t("SELECT_REQUIRED_OPTIONS"), { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
        //if in any case, modifiers are incomplete from backend so then we will open product modal
        props.selectedItem && props.selectedItem(props.product);
      }
    }}>
      <button
        className="ri-add-line rgeister-btn Add-web px-2"
        onClick={(e) => {
          if (props.product.is_active == 1 && props.itemReady(props.product.modifiers)) {
            addItem(e, storeSelected)
          }
          handleAddToCart(props.product)
        }}
      ><span>{t("ADDTOBUCKET")}</span></button>
      <button className="ri-add-line rgeister-btn Add-mobil px-2"
        onClick={(e) => {
          if (props.product.is_active == 1 && props.itemReady(props.product.modifiers)) {
            addItem(e, storeSelected)
          }
          handleAddToCart(props.product)
        }}
      ><span>{t("ADDTOBUCKET")}</span></button>
    </div>
  )
}
